import axios from 'axios';
import I18n from 'i18n-js';
import * as Routes from '@/modules/routes';
import stripStandardsAliasPrefix from '@/utils/stripStandardsAliasPrefix';
import { BenchmarkResponse, QuestionScore, StudentScores, Tag } from './types';

export const SCORE_RANGES = [
  { className: 'tw-bg-green/50', from: 80, to: 100 },
  { className: 'tw-bg-orange/50', from: 60, to: 79 },
  { className: 'tw-bg-red/50', from: 0, to: 59 },
];

export const scoreColorClass = (score: number | null) => {
  if (score === null) return 'tw-bg-light-grey';

  return (SCORE_RANGES.find(range => score >= range.from) ?? SCORE_RANGES[SCORE_RANGES.length - 1]).className;
};

export const tagDescription = (tag: Tag) => {
  const description = I18n.locale === 'es' && tag.description_es ? tag.description_es : tag.description_en;

  return stripStandardsAliasPrefix(description, tag.alias);
};

export const fetchReport = async (classroomId: number) => {
  const params = { classroom_id: classroomId };
  const { data } = await axios.get<BenchmarkResponse>(Routes.plato_api_student_benchmarks_tags_path(), { params });

  return {
    students: data.students.map<StudentScores>(student => ({
      id: student.id,
      name: `${student.first_name} ${student.last_name}`,
      scores: student.scores,
    })),
    tags: data.tags,
  };
};

export const fetchQuestionScores = async (classroomId: number, studentId: number, tagId: number) => {
  const params = { classroom_id: classroomId, student_id: studentId, tag_id: tagId };
  const url = Routes.plato_api_student_benchmarks_for_tag_tags_path();
  const { data } = await axios.get<QuestionScore[]>(url, { params });

  return data.filter(question => question?.question_answer?.score);
};
